import {FormSection} from '@/components/commons/form-section/FormSection'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {ProjectFormSenderField} from '@/features/projects/components/project-form/project-form-sender-field/ProjectFormSenderField'
import {ProjectFormSpecialistField} from '@/features/projects/components/project-form/project-form-specialist-field/ProjectFormSpecialistField'
import {useTranslation} from '@/translations/i18n'

export const ProjectFormReferringSpecialistSection = () => {
    const {t} = useTranslation()
    return (
        <FormSection title={t('projects:referring_entity')}>
            <Grid columns={3} rowGap={4}>
                <GridItem spanColumn={2}>
                    <ProjectFormSenderField />
                </GridItem>
                <ProjectFormSpecialistField />
            </Grid>
        </FormSection>
    )
}
